import { createContext, useContext } from "react";
import { ITypesCharacteristicsCreateContext } from "./types";

export const TypesCharacteristicsCreateContext = createContext<ITypesCharacteristicsCreateContext | null>(
  null
);

export const useTypesCharacteristicsCreateContext = () => {
  const context = useContext(TypesCharacteristicsCreateContext);
  if (context === null) {
    throw new Error("useContext must be inside a Provider with a value");
  }
  return context;
};
